import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LabelType, ProductionOrderPrintedLabelInfo } from 'chronos-core-client';

@Component({
  selector: 'app-print-label-list',
  templateUrl: './print-label-list.component.html',
  styleUrls: ['./print-label-list.component.scss']
})
export class PrintLabelListComponent {
  @Input() public printLabelData: ProductionOrderPrintedLabelInfo;
  @Input() public productionOrderId: number;
  @Output() public quantityChanged = new EventEmitter<LabelType>();

  public onQuantityChanged(event: LabelType): void {
    this.quantityChanged.emit(event);
  }
}